import { render, staticRenderFns } from "./SpecSplitPopupWrappable.vue?vue&type=template&id=2300ef33&scoped=true&lang=pug&"
import script from "./SpecSplitPopupWrappable.vue?vue&type=script&lang=js&"
export * from "./SpecSplitPopupWrappable.vue?vue&type=script&lang=js&"
import style0 from "./SpecSplitPopupWrappable.vue?vue&type=style&index=0&id=2300ef33&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2300ef33",
  null
  
)

export default component.exports